import { render, staticRenderFns } from "./lab_result.vue?vue&type=template&id=3f931fb3&scoped=true&"
import script from "./lab_result.vue?vue&type=script&lang=js&"
export * from "./lab_result.vue?vue&type=script&lang=js&"
import style0 from "./lab_result.vue?vue&type=style&index=0&id=3f931fb3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f931fb3",
  null
  
)

export default component.exports